import React, { useMemo } from 'react';

import { Modal as AntModal } from 'antd';

import { FullScreenMobileModalStyles, StyledModal } from './styles';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('modal');

const FULL_SCREEN_MOBILE_CLASS = 'modal--full-screen-mobile';

const SCROLLABLE_STYLES = {
  content: { maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  header: { flexShrink: 0 },
  body: { flex: 1, overflowY: 'auto', padding: 0 },
  footer: { flexShrink: 0 },
};

const Modal = ({ isOpen, onOk, onCancel, fullScreenMobile, scrollable, centered, styles, children, ...props }) => {
  const resolvedStyles = useMemo(() => {
    if (!scrollable) return styles;

    if (!styles) return SCROLLABLE_STYLES;

    return {
      ...SCROLLABLE_STYLES,
      ...styles,
      content: { ...SCROLLABLE_STYLES.content, ...styles?.content },
      header: { ...SCROLLABLE_STYLES.header, ...styles?.header },
      body: { ...SCROLLABLE_STYLES.body, ...styles?.body },
      footer: { ...SCROLLABLE_STYLES.footer, ...styles?.footer },
    };
  }, [scrollable, styles]);

  return (
    <>
      {fullScreenMobile && <FullScreenMobileModalStyles />}
      <AntModal
        open={isOpen}
        onOk={onOk}
        onCancel={onCancel}
        centered={scrollable || centered}
        wrapClassName={fullScreenMobile ? FULL_SCREEN_MOBILE_CLASS : undefined}
        styles={resolvedStyles}
        {...props}
      >
        <StyledModal>
          <div className={b()}>{children}</div>
        </StyledModal>
      </AntModal>
    </>
  );
};

export default Modal;
